<template>
    <a-select v-model="organId" placeholder="请选择单位" :disabled="disabled" style="width:100%" :allowClear="allowClear">
        <a-select-option v-for="item in organList" :key="item.organId" :value="item.organId">
            {{ item.name }}
        </a-select-option>
    </a-select>
</template>

<script>
import apiUtils from '@/common/apiUtil';
import utils from '@/common/utils';
export default {
    name: 'ChooseOrgan',
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        allowClear: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            disabled: apiUtils.getOrganId() ? true : false,
            organId: this.value ? this.value : '',
            organList: []
        };
    },
    watch: {
        value(newVal) {
            this.organId = newVal ? newVal : '';
            this.$emit('input', newVal);
        },
        organId(newVal) {
            let v = newVal ? newVal : '';
            this.$emit('input', v);
            this.$emit('change', v);
        }
    },
    mounted() {
        this.loadOrganList();
    },
    methods: {
        async loadOrganList() {
            try {
                const list = await apiUtils.getAllOrganList();
                this.organList = list || [];
            } catch (error) {
                console.error('加载组织列表失败:', error);
            }
        }
    }
};
</script>

<style scoped></style>